module.exports = __webpack_public_path__ + "media/images/flags/4x3/maf-1bcab66ba7724944c927c3b05d91af49.svg";